import client from './client'
import type { SupplierUser } from '@/types/suppliers'

export function sendMagicLink(email: string) {
  return client.post<{ sent: boolean }>('/portal/session/magic_link', { email })
}

export function getSession() {
  return client.get<SupplierUser>('/portal/session')
}

export function verifyCode(code: string, email: string) {
  return client.post<{ success: boolean }>('/portal/session/verify_code', { code, email })
}

export function destroySession() {
  return client.delete('/portal/session')
}
